import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const archivePerson = async ({
	id,
	archived
}: {
	id: string;
	archived: boolean;
}) => {
	const response = await cmsClient.patch<IRetailUser>(
		`/homepage/admin/store/user/${id}/`,
		{ archived }
	);

	return response.data;
};

const useArchivePerson = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_: unknown,
		variables: { id: string; archived: boolean }
	) => {
		const message = variables.archived ? "Person archived" : "Person restored";

		toast.success(<CustomToast type="Success" message={message} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-people"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(archivePerson, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useArchivePerson;
